import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "grid",
  "use": "grid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"grid\"><path d=\"M2 13.8c0 .11.09.2.2.2h5a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2h-5a.2.2 0 0 0-.2.2zm0-7c0 .11.09.2.2.2h5a.2.2 0 0 0 .2-.2V2.2a.2.2 0 0 0-.2-.2h-5a.2.2 0 0 0-.2.2zm6.6 7c0 .11.09.2.2.2h5a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2h-5a.2.2 0 0 0-.2.2zM8.8 2a.2.2 0 0 0-.2.2v4.6c0 .11.09.2.2.2h5a.2.2 0 0 0 .2-.2V2.2a.2.2 0 0 0-.2-.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol